import { DataTableColumnHeader } from "@/shared/components/table";
import { ColumnDef } from "@tanstack/react-table";
import { useMemo } from "react";
import type {
  CollectionErrorRow,
  CollectionInProgressRow,
  CollectionSuccessRow,
} from "../types/collection-types";

export function useCollectionSuccessColumns() {
  return useMemo<ColumnDef<CollectionSuccessRow>[]>(
    () => [
      {
        accessorKey: "requested_time",
        header: ({ column }) => <DataTableColumnHeader column={column} title="requested_time" />,
        cell: ({ row }) => row.original.requested_time,
      },
      {
        accessorKey: "trans_id",
        header: ({ column }) => <DataTableColumnHeader column={column} title="trans_id" />,
      },
      {
        accessorKey: "channel",
        header: ({ column }) => <DataTableColumnHeader column={column} title="channel" />,
      },
      {
        accessorKey: "dw_account_id",
        header: ({ column }) => <DataTableColumnHeader column={column} title="dw_account_id" />,
      },
      {
        accessorKey: "collect_data_type",
        header: ({ column }) => <DataTableColumnHeader column={column} title="collect_data_type" />,
      },
      {
        accessorKey: "collect_type",
        header: ({ column }) => <DataTableColumnHeader column={column} title="collect_type" />,
      },
      {
        accessorKey: "target_date",
        header: ({ column }) => <DataTableColumnHeader column={column} title="target_date" />,
      },
    ],
    []
  );
}

export function useCollectionErrorColumns() {
  return useMemo<ColumnDef<CollectionErrorRow>[]>(
    () => [
      {
        accessorKey: "requested_time",
        header: ({ column }) => <DataTableColumnHeader column={column} title="requested_time" />,
        cell: ({ row }) => row.original.requested_time,
      },
      {
        accessorKey: "trans_id",
        header: ({ column }) => <DataTableColumnHeader column={column} title="trans_id" />,
      },
      {
        accessorKey: "channel",
        header: ({ column }) => <DataTableColumnHeader column={column} title="channel" />,
      },
      {
        accessorKey: "dw_account_id",
        header: ({ column }) => <DataTableColumnHeader column={column} title="dw_account_id" />,
      },
      {
        accessorKey: "collect_data_type",
        header: ({ column }) => <DataTableColumnHeader column={column} title="collect_data_type" />,
      },
      {
        accessorKey: "collect_type",
        header: ({ column }) => <DataTableColumnHeader column={column} title="collect_type" />,
      },
      {
        accessorKey: "target_date",
        header: ({ column }) => <DataTableColumnHeader column={column} title="target_date" />,
      },
      {
        accessorKey: "err_code",
        header: ({ column }) => <DataTableColumnHeader column={column} title="err_code" />,
        cell: ({ row }) => row.original.err_code || "-",
      },
      {
        accessorKey: "err_msg",
        header: ({ column }) => <DataTableColumnHeader column={column} title="err_msg" />,
        cell: ({ row }) => row.original.err_msg || "-",
      },
    ],
    []
  );
}

export function useCollectionInProgressColumns() {
  return useMemo<ColumnDef<CollectionInProgressRow>[]>(
    () => [
      {
        accessorKey: "trans_id",
        header: ({ column }) => <DataTableColumnHeader column={column} title="trans_id" />,
      },
      {
        accessorKey: "channel",
        header: ({ column }) => <DataTableColumnHeader column={column} title="channel" />,
        cell: ({ row }) => row.original.channel || "-",
      },
      {
        accessorKey: "dw_account_id",
        header: ({ column }) => <DataTableColumnHeader column={column} title="dw_account_id" />,
        cell: ({ row }) => row.original.dw_account_id || "-",
      },
      {
        accessorKey: "collect_data_type",
        header: ({ column }) => <DataTableColumnHeader column={column} title="collect_data_type" />,
        cell: ({ row }) => row.original.collect_data_type || "-",
      },
      {
        accessorKey: "target_date",
        header: ({ column }) => <DataTableColumnHeader column={column} title="target_date" />,
      },
      {
        accessorKey: "phase",
        header: ({ column }) => <DataTableColumnHeader column={column} title="phase" />,
        cell: ({ row }) => row.original.phase || "-",
      },
      {
        accessorKey: "job_start_time",
        header: ({ column }) => <DataTableColumnHeader column={column} title="job_start_time" />,
        cell: ({ row }) => row.original.job_start_time || "-",
      },
      {
        accessorKey: "retry_info",
        header: ({ column }) => (
          <DataTableColumnHeader column={column} title="retry_count / max_retry" />
        ),
      },
    ],
    []
  );
}